import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const OddsHeadingWrapper = styled.div`
  display: grid;
  grid-template-columns: 80px 80px 1fr;
  column-gap: 20px;

  margin: 10px 0;
  padding: 0 15px;

  @media (max-width: 420px) {
    column-gap: 10px;
  }

  @media (max-width: 360px) {
    grid-template-columns: 80px 1fr;
  }

  margin: 10px 15px;
  padding: 5px 0;
  border-bottom: 1px solid var(--oc-border);

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      display: none;
    }
  }
`;

const oddsHeadingPart = styled.h4`
  ${OddsHeadingWrapper} & {
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 15px;
    color: var(--oc-text-subtext);
  }
`;

export const BookmakersHeading = styled(oddsHeadingPart)`
  grid-column: 1;
  justify-self: center;
`;

export const SignUpHeading = styled(oddsHeadingPart)`
  grid-column: 2;
`;

export const OddsHeading = styled(oddsHeadingPart)`
  justify-self: center;
`;

export const EachWayTermsHeading = styled(oddsHeadingPart)`
  justify-self: right;
`;

export const MobileOddsHeadingWrapper = styled.div`
  grid-column: -2;
  justify-content: space-evenly;
  display: flex;
`;

export const SingleHeading = css`
  justify-content: flex-end;
  margin-right: 17px;
`;
